import fetchEssentialScores from './fetch_essential_scores';

export default {
  fetchEssentialScores,
};
